// SignUpMemberCreationSection.js
import React from "react";
import { Avatar, Box, Divider, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import SelectYourRoleStep2 from "./SelectYourRoleStep2";
import CreatorProfileStep3 from "./CreatorProfileStep3";
import SignUpStep1 from "./SignUpStep1";
import MainPlatformsStep4 from "./MainPlatformsStep4";
import GoalsAndContactStep5 from "./GoalsAndContactStep5";

const signUpButtonsData = [
  { AvatarText: "1", primaryText: "Step 1", secondaryText: "Sign Up" },
  { AvatarText: "2", primaryText: "Step 2", secondaryText: "Select Your Role" },
  { AvatarText: "3", primaryText: "Step 3", secondaryText: "Creator Profile" },
  { AvatarText: "4", primaryText: "Step 4", secondaryText: "Main Platforms" },
  { AvatarText: "5", primaryText: "Step 5", secondaryText: "Contact" },
];

function SignUpMemberCreationSection() {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();

  // The next step function is triggered after each step
  const goToNextStep = () => {
    if (step < 5) {
      setStep((cur) => cur + 1);
    } else {
      // Final step done => navigate to login
      navigate("/login");
    }
  };

  return (
    <Stack
      position="relative"
      sx={{
        overflow: "hidden",
        height: "auto",
      }}
    >
      <Box
        component="img"
        src="/images/pitchers.png"
        sx={{
          width: "386.52px",
          height: "366.16px",
          borderRadius: "57px",
          filter: "blur(4px)",
          transform: "rotate(13.74deg)",
          position: "absolute",
          right: -128,
          bottom: -100,
          overflow: "hidden",
        }}
      />
      <Box
        sx={{
          width: "600px",
          height: "600px",
          background:
            "linear-gradient(134.15deg, rgba(255,255,255,0.16) -1.52%, rgba(253,223,89,0.16) 100%)",
          position: "absolute",
          top: "-247px",
          left: "384px",
          borderRadius: "50%",
          filter: "blur(30px)",
        }}
      />
      <Stack
        id="nav-buttons"
        direction="row"
        sx={{
          px: "0px",
          pt: "40px",
          position: "relative",
          gap: "0px",
          width: "100%",
          justifyContent: "space-between",
          '& > *:first-of-type': {
            ml: "0px"
          },
          '& > *:last-of-type': {
            mr: "0px"
          }
        }}
      >
        {signUpButtonsData.map((btn, i) => (
          <React.Fragment key={i}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "2px",
                minWidth: "100px",
                position: "relative",
                zIndex: 1
              }}
            >
              <Avatar
                sx={{
                  bgcolor: step >= i + 1 ? "#000000" : "transparent",
                  color: step >= i + 1 ? "#FDDF59" : "#000000",
                  fontFamily: "Inter",
                  fontWeight: 600,
                  fontSize: "25px",
                  lineHeight: "30.26px",
                  textAlign: "center",
                  width: "55px",
                  height: "55px",
                  border:
                    step >= i + 1 ? "1px solid transparent" : "1px solid #000000",
                }}
              >
                {btn.AvatarText}
              </Avatar>
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Inter",
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "19px",
                  mt: 0.5
                }}
              >
                {btn.primaryText}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "17px",
                }}
              >
                {btn.secondaryText}
              </Typography>
            </Box>
            {i < 4 && (
              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  top: '-20px',
                  mx: 0
                }}
              >
                <Divider
                  orientation="horizontal"
                  sx={{
                    width: "100%",
                    border: "1px dashed #363636",
                    height: ".01px",
                    opacity: step >= i + 1 ? "1" : "0",
                    borderRadius: "50px"
                  }}
                />
              </Box>
            )}
          </React.Fragment>
        ))}
      </Stack>
      <Stack
        id="main-container"
        alignSelf="center"
        justifySelf="center"
        sx={{ my: "auto", minWidth: "445px", py: "100px" }}
      >
        {step === 1 && <SignUpStep1 onSuccess={goToNextStep} />}
        {step === 2 && <SelectYourRoleStep2 onSuccess={goToNextStep} />}
        {step === 3 && <CreatorProfileStep3 onSuccess={goToNextStep} />}
        {step === 4 && <MainPlatformsStep4 onSuccess={goToNextStep} />}
        {step === 5 && <GoalsAndContactStep5 onFinish={goToNextStep} />}
      </Stack>
    </Stack>
  );
}

export default SignUpMemberCreationSection;
